import React from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useState } from "react";

// INPUT VALUE ARE HARDCODED

const LoginForm = ({ setIsLoggedIn }) => {
	const navigate = useNavigate();

	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});

	const [showPassword, setShowPassword] = useState(false);

	function changeHandler(event) {
		setFormData((prevData) => ({
			...prevData,
			[event.target.name]: event.target.value,
		}));
	}

	function submitHandler(event) {
		event.preventDefault();
		setIsLoggedIn(true);
		toast.success("Logged In");
		console.log("Printing the formData ");
		navigate("/farmers-dashboard");
	}

	return (
		<form
			onSubmit={submitHandler}
			className="flex flex-col w-full gap-y-4 mt-6 mr-5"
		>
			<label className="w-full">
				<p className="text-[0.875rem] text-richblack-5 mb-1 leading-[1.375rem]">
					Email Address<sup className="text-pink-200">*</sup>
				</p>
				<input
					type="email"
					// value={formData.email}
					value="test@test.com"
					onChange={changeHandler}
					placeholder="Enter email address (optional)"
					name="email"
					className="bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full p-[12px]"
				/>
			</label>
			{/* For mobile number */}
			<label className="w-full">
				<p className="text-[0.875rem] text-richblack-5 mb-1 leading-[1.375rem]">
					Mobile<sup className="text-pink-200">*</sup>
				</p>
				<input
					required
					type="tel"
					// value={formData.mobile}
					value="9236578920"
					onChange={changeHandler}
					placeholder="10-digit number"
					name="mobile"
					className="bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full p-[12px]"
				/>
			</label>

			<label className="w-full relative">
				<p className="text-[0.875rem] text-richblack-5 mb-1 leading-[1.375rem]">
					Password<sup className="text-pink-200">*</sup>
				</p>
				<input
					required
					type={showPassword ? "text" : "password"}
					// value={formData.password}
					value="123"
					onChange={changeHandler}
					placeholder="Enter Password"
					name="password"
					className="bg-richblack-800 rounded-[0.5rem] text-richblack-5 w-full p-[12px]"
				/>

				<span
					className="absolute right-3 top-[38px] cursor-pointer"
					onClick={() => setShowPassword((prev) => !prev)}
				>
					{showPassword ? (
						<AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
					) : (
						<AiOutlineEye fontSize={24} fill="#AFB2BF" />
					)}
				</span>

				<Link to="#">
					<p className="text-xs mt-1 text-blue-500 max-w-max ml-auto">
						Forgot Password
					</p>
				</Link>
			</label>

			<button className="bg-yellow-50 rounded-[8px] font-medium text-richblack-900 px-[12px] py-[8px] mt-6">
				Sign In
			</button>
		</form>
	);
};

export default LoginForm;
